// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H14.8464C13.4127 21.8077 12.5 20.0104 12.5 18C12.5 14.4101 15.4101 11.5 19 11.5C19.6978 11.5 20.3699 11.61 21 11.8135V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.0001 13V20.1092L22.5082 17.6297L23.9143 19.0519L19.0001 23.9103L14.0859 19.0519L15.492 17.6297L18.0001 20.1092V13H20.0001Z"}}]};

const FileDownloadFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-download-filled',
    ref,
    icon: element,
  },
));

FileDownloadFilledIcon.displayName = 'FileDownloadFilledIcon';

export default FileDownloadFilledIcon;
